/**
 * Adattatore delle due mutation di download che ogni superficie porta con sé.
 * Ricerca attiva e talent pool hanno endpoint distinti (il pool autorizza sulla
 * membership del pool, la ricerca sulla discoverability), ma la REGOLA di scelta
 * è la stessa — ed è quella che vive qui.
 */
export type CvDownloadMutations = {
  /** Scarica il PDF di un candidato. `onSuccess` corre solo a file ottenuto. */
  single: {
    mutate: (freelancerId: string, onSuccess: () => void) => void;
    isPending: boolean;
  };
  /** Scarica lo ZIP di più candidati, nell'ordine ricevuto. */
  bundle: {
    mutate: (freelancerIds: string[], onSuccess: () => void) => void;
    isPending: boolean;
  };
};

/**
 * Download dei CV anonimi per una selezione di candidati.
 *
 * Sceglie la forma del file in base a quanti candidati ci sono — un solo
 * candidato scarica il suo PDF, due o più uno ZIP — così chi ne vuole uno non si
 * ritrova un archivio da aprire. È la stessa regola della barra bulk dell'ATS
 * (`BulkActionBar`), qui in un posto unico perché la usano il modale del
 * dettaglio e la barra flottante di entrambe le superfici.
 */
export const useCvDownload = (
  mutations: CvDownloadMutations,
  /**
   * Chiamato a download RIUSCITO, non al click: è qui che la barra flottante
   * svuota la selezione. Su errore la selezione resta, altrimenti un 500
   * costringerebbe a ricomporre a mano i candidati per riprovare.
   */
  onDownloaded?: () => void,
) => {
  /* Funzioni derivate, non `createMemo`: leggono flag già reattivi, non c'è
     nulla da memoizzare (vedi "no derived state" negli standard). */
  const isPending = () =>
    mutations.single.isPending || mutations.bundle.isPending;

  /** No-op su selezione vuota: non esiste un download di zero candidati. */
  const download = (freelancerIds: string[]) => {
    if (freelancerIds.length === 0) return;
    const done = () => onDownloaded?.();
    if (freelancerIds.length === 1) {
      mutations.single.mutate(freelancerIds[0], done);
    } else {
      mutations.bundle.mutate(freelancerIds, done);
    }
  };

  return { download, isPending };
};
